<!--  

FILTRO DE FUNIL, USUARIOS, EQUIPES UTILIZADO NOS PAINEIS DE NEGOCIOS, PESSOAS E ORGANIZACOES



params: {
    funil: true,
    usuario: true,
}

-->



<script>

// import CrmFunilNovo from './crm-pessoa-novo-form'
import { SysVars } from '../main';

export default {
    props: {
      params: Object 
    },

    data () {
        return {
            usuarioOptions: [],

            indexUsuarioSelected: null,

            codusuario: null,
            codequipe: null,
            codfunil: null,
        }
    },

    components: {
        // CrmFunilForm
    },

    computed: {

        configCrm: function () {
            return this.$store.getters.getConfigCrm
        },
        usuarioList: function () {
            if (this.$store.getters.getConfigCrm)
                return this.$store.getters.getConfigCrm.usuarios_filtro
            else
                return []
        },
        equipeList: function () {
            if (this.$store.getters.getConfigCrm)
                return this.$store.getters.getConfigCrm.equipes
            else
                return []
        },
        funilList: function () {
            if (this.$store.getters.getConfigCrm)
                return this.$store.getters.getConfigCrm.funil
            else
                return []
        },

        administrador: function () {
            return SysVars.usuarioAdministrador
        },
    },

    watch: {
        configCrm: function () {
            this.preparaFiltro()
        }

    },

    filters: {

    },

    methods: {
        handleEditarFunil(codfunil) {
            this.$emit('editfunil', this.codfunil)
        },

        handleNovoFunil(codfunil) {
            console.log('novofunil')
            this.$emit('novofunil')
        },

        handleChangeUsuario () {
            this.codusuario = this.usuarioOptions[this.indexUsuarioSelected]
            if (this.codusuario == -1)
              this.codusuario = null
            this.$emit('changeUsuario', this.codusuario)
        },

        handleChangeFunil () {
            if (this.codfunil == -1)
              this.codfunil = null
            this.$emit('changeFunil', this.codfunil)
        },

        preparaFiltro () {
            if (!this.codfunil && this.funilList.length > 0)
                this.codfunil = this.funilList[0].codfunil
            
            //monta a lista de usuarios e equipes
            let seq = 0
            this.usuarioOptions = []
            this.usuarioOptions.push({ group: 'Usuários' })
            for (var x = 0; x < this.usuarioList.length; x++) {
                this.usuarioOptions.push({ id: seq, codusuario: this.usuarioList[x].codusuario, text: this.usuarioList[x].nome })
                seq = seq + 1
            }
            if (this.equipeList.length > 0) {
                this.usuarioOptions.push({ group: 'Equipe' })
                for (var x = 0; x < this.equipeList.length; x++) {
                    this.usuarioOptions.push({ id: seq, codequipe: this.equipeList[x].codequipe, text: this.equipeList[x].nome })
                    seq = seq + 1
                }
            }

            if (!this.codusuario)
              this.codusuario = this.usuarioList[0].codusuario

        },

    },

    created () {
        this.preparaFiltro()
    }

}

</script>

<template>
    <div class="row align-items-center">
        <!-- filtro usuarios e equipes -->
        <!-- <div class="col" v-if="params.usuario">
                <div class="input-group">
                    <select ref="input" class="form-control form-control-sm" v-model="indexUsuarioSelected" @change="handleChangeUsuario" placeholder="Usuários">
                        <option v-for="opt in usuarioOptions" :key="opt.id" :value="opt.id">{{ opt.text }}</option>
                    </select>
                </div>
        </div> -->
        <!-- filtro funil -->
        <div class="col" v-if="params.funil">
            <div class="input-group align-items-center">
                <select ref="input" class="form-control form-control-sm" v-model="codfunil" @change="handleChangeFunil">
                    <option v-for="opt in funilList" :key="opt.codfunil" :value="opt.codfunil">{{ opt.descricao }}</option>
                    <!-- <option value="-1"> Todos </option> -->
                    <!-- <option v-if="administrador" value="novo"><i class="fa fa-plus"></i> Novo Funil</option>
                    <option v-if="administrador" value="editar"><i class="fa fa-pencil"></i> Editar Funil</option> -->
                </select>
                <v-button v-if="administrador" class="ml-1" title="Incluir novo funil de vendas" icon="fa-plus" data-toggle="tooltip" data-placement="top" @click="handleNovoFunil"></v-button>
                <v-button v-if="administrador" title="Editar funil atual" icon="fa-pencil" data-toggle="tooltip" data-placement="top" @click="handleEditarFunil"></v-button>
            </div>
        </div>

        <!-- <crm-funil-form v-if="showFormNovo" :index="this.codpessoa" :crud="this.crud" @closeform="closeForm"></crm-funil-form> -->
    </div>
</template>


<style>

</style>



// WEBPACK FOOTER //
// src/forms-crm/crm-filtros.vue